import config from "../../../../api_config.json";
import { AI_FLAG_LABELS } from "../../../shared/GiottoAiResults/aiResultTypes";

// Etichette delle elaborazioni AI, allineate ai nomi usati nel menu di OrgDetailsV2.
export { AI_FLAG_LABELS };

export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return "-";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString() + " " + date.toLocaleTimeString();
};

// Nella card della griglia lo spazio è poco: solo la data, senza orario.
export const formatShortDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString();
};

export const isImage = (mimeType) => Boolean(mimeType && mimeType.startsWith("image/"));

// Etichette delle sole elaborazioni AI attive sull'allegato.
export const getAiFlags = (item) =>
  Object.keys(AI_FLAG_LABELS)
    .filter((flag) => Boolean(item && item[flag]))
    .map((flag) => AI_FLAG_LABELS[flag]);

export const getParseDashboardUrl = (objectId, isProd) =>
  `${config.parseDashboard[isProd ? "prod" : "dev"]}` +
  `/browser/allegati?filters=[{"field":"objectId","constraint":"eq","compareTo":"${objectId}"}]`;
